// @flow

import type {MarkdocNodeRegistration} from 'docs/markdoc';

export const item: MarkdocNodeRegistration = {
  component: 'ListItem',
  node: 'item',
  children: [
    'inline',
    'heading',
    'paragraph',
    'image',
    'table',
    'tag',
    'fence',
    'blockquote',
    'list',
    'hr',
  ],
  attributes: {
    number: {type: Number},
  },
};
